package com.sddamico.draftmachine.pages.draft

import com.sddamico.draftmachine.models.LotteryEntryResponse
import com.sddamico.draftmachine.models.LotteryStateResponse

/** One lottery team's static slice of the number wheel (inclusive bounds, 1-based). */
data class LotteryRange(val entry: LotteryEntryResponse, val lo: Int, val hi: Int)

/**
 * The static number ranges the draw is made over: weighted entries in base order, cumulative.
 * Ranges never shift as teams are drawn — a drawn number always lands in its winner's range.
 */
fun lotteryRanges(entries: List<LotteryEntryResponse>): List<LotteryRange> {
  var acc = 0
  return entries.filter { it.weight != null }.sortedBy { it.baseOrder }.map { entry ->
    val lo = acc + 1
    acc += entry.weight!!
    LotteryRange(entry, lo, acc)
  }
}

fun lotteryTotalWeight(entries: List<LotteryEntryResponse>): Int =
  entries.sumOf { it.weight ?: 0 }

/** "$weight/$total" as a whole percentage — the "% AT NO. 1" stamp. */
fun oddsAtNo1(weight: Int, totalWeight: Int): Int =
  if (totalWeight <= 0) 0 else (weight * 100.0 / totalWeight + 0.5).toInt()

/** Teams below the lottery line, in base order — they hold round-1 slots L+1..T. */
fun staticEntries(state: LotteryStateResponse): List<LotteryEntryResponse> =
  state.entries.filter { it.weight == null }.sortedBy { it.baseOrder }

/** The revealed winner of draw [slot] (1-based), or null while masked/undrawn. */
fun drawnEntry(state: LotteryStateResponse, slot: Int): LotteryEntryResponse? =
  state.entries.firstOrNull { it.drawSlot == slot }

/** The most recently revealed draw, or null before the first spin resolves. */
fun latestDraw(state: LotteryStateResponse): LotteryEntryResponse? =
  if (state.revealedCount == 0) null else drawnEntry(state, state.revealedCount)

fun pad2(n: Int): String = n.toString().padStart(2, '0')
